module.exports = "<block\n    class=\"example-rounder\"\n    style=\"height: 300px;\"\n    cols=\"1fr 1fr 1fr\"\n    rounder=\"99.99999999999999%\"\n    pattern=\"first second third\">\n    <div slot=\"first\" class=\"area-1\"></div>\n    <div slot=\"second\" class=\"area-2\"></div>\n    <div slot=\"third\" class=\"area-3\"></div>\n</block>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/example/9-rounder.html
// module id = 213
// module chunks = 1